// extracted by mini-css-extract-plugin
export default {"video_poster":"index_video_poster_uBSnQ","miniVideo_poster":"index_miniVideo_poster_jrb6P"};